import { render, staticRenderFns } from "./PokedexRecords.vue?vue&type=template&id=4b31b99c"
import script from "./PokedexRecords.vue?vue&type=script&lang=js"
export * from "./PokedexRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports